import React, { useState } from "react";
import { Menu, MenuItem, Box, Typography, Button, IconButton, Divider } from "@mui/material";
import ArrowDropDownIcon from "@mui/icons-material/ArrowDropDown";
import CustomButton from "components/CustomButtons";
import { INTERVIEW_TYPE, MockPublishingSteps, TemplateType } from "./constant";

export default function Banner({ 
  data, setOpenNextround, setOpenCodingMock, activeTab , setInterviewType , setCurrentCodingStep , 
  setTemplateType , setOpenShortList , setJobRoleTask}) {
  const [anchorEl, setAnchorEl] = useState(null);

  const handleMainClick = () => {
    if (activeTab === 0) {
      setOpenNextround(true);
    } else if (activeTab === 1) {
      setOpenCodingMock(true);
    } 
  };

  const handleMenuClick = (event) => {
    event.stopPropagation();
    setAnchorEl(event.currentTarget);
  };

  const handleMenuClose = () => {
    setAnchorEl(null);
  };

  const handleCreateCodingContest = () => {
    setTemplateType(TemplateType.CONTEST)
    setInterviewType(INTERVIEW_TYPE.CONTEST)
    setCurrentCodingStep(MockPublishingSteps.MOCK_DETAILS)
    setOpenCodingMock(true)
    handleMenuClose();
  };

  const getMainButtonText = () => {
    switch (activeTab) {
      case 0:
        return "Create Next Round Mock";
      case 1:
        return "Create Coding Mock";
      case 2:
        return "Create Shortlisting";
      default:
        return "Create Mock";
    }
  };

  const getMenuItemText = () => {
    switch (activeTab) {
      case 1:
        return "Create Coding Contest";
      case 2:
        return "Create Shortlisting Contest";
      default:
        return "Create Contest";
    }
  };

  return (
    <Box sx={{ borderRadius: 2, display: "flex", flexDirection: "column" }}>
      <Box
        sx={{
          display: "flex",
          width: "100%",
          padding: (theme) => theme.spacing(12, 10),
          backgroundColor: (theme) => theme.palette.shades["clr-white-900"],
          justifyContent: "space-between",
          position: "relative",
        }}
      >
        <Box sx={{ display: "flex", flexDirection: "column", gap: 4, maxWidth: '70%', width: "100%" }}>
          {data.title}
          {activeTab == 2 ? 
            (
              <Box display='flex' flexDirection='column' gap='12px'>
                {data.subTitle.map((data , key) => (
                  <Typography variant="body01-bold" color='neutral.clr-700'>
                    • {data}
                  </Typography>
                ))}
              </Box>
            )
          : (
            <Typography variant="body01-bold" color="neutral.clr-500">
              <i>{data.subTitle}</i>
            </Typography>
          )}

          {activeTab === 0 ? (
            <CustomButton
              variant="contained"
              sx={{ width: 260 }}
              onClick={handleMainClick}
              size="medium"
            >
              <Typography variant="body01-bold">
                {getMainButtonText()}
              </Typography>
            </CustomButton>
          ) : (activeTab === 1 ) ? (
            <Box sx={{ position: "relative", width: 260 }}>
              <Box sx={{ display: "flex", height: 44 , alignItems : 'center' }}>
                <Button
                  variant="contained"
                  onClick={handleMainClick}
                  sx={{
                    flex: 1,
                    height:'44px',
                    backgroundColor: "#003E8C",
                    borderTopRightRadius: 0,
                    borderBottomRightRadius: 0,
                    textTransform: "none",
                    "&:hover": {
                      backgroundColor: "#1151A6",
                    },
                  }}
                >
                  <Typography variant="body01-bold">
                    {getMainButtonText()}
                  </Typography>
                </Button>
                <Divider 
                  orientation="vertical" 
                  sx={{ 
                    height: '38px',
                    width: '1px',
                    borderColor : '#FFFFFF'
                  }} 
                />
                <Button
                  variant="contained"
                  onClick={handleMenuClick}
                  sx={{
                    minWidth: 44,
                    width: 44,
                    height : 44,
                    backgroundColor: "#003E8C",
                    borderTopLeftRadius: 0,
                    borderBottomLeftRadius: 0,
                    boxShadow : 'none',
                    "&:hover": {
                      backgroundColor: "#1151A6",
                    },
                  }}
                >
                  <ArrowDropDownIcon />
                </Button>
              </Box>
              
              <Menu
                anchorEl={anchorEl}
                open={Boolean(anchorEl)}
                onClose={handleMenuClose}
                anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
                transformOrigin={{ vertical: "top", horizontal: "right" }}
                sx={{
                  "& .MuiPaper-root": {
                    minWidth: 260,
                    boxShadow: (theme) => theme.shadows[3],
                    borderRadius: 1,
                    marginTop: 0.5,
                    padding : 0
                  },
                }}
              >
                <MenuItem 
                  onClick={handleCreateCodingContest}
                  sx={{
                    fontSize: "14px",
                    padding :0,
                    paddingLeft : 8
                  }}
                >
                  <Typography variant="body01-bold">
                     {getMenuItemText()}
                  </Typography>
                </MenuItem>
              </Menu>
            </Box>
          ) : (
            <Box display='flex' gap='8px'>
              <CustomButton size="medium" onClick={() => {
                setOpenShortList(true);
                setJobRoleTask(false)
              }}>
                Company specific task
              </CustomButton>
              <CustomButton variant="outlined" size="medium" onClick={() => {
                setOpenShortList(true);
                setJobRoleTask(true)
              }}>
                Job role specific task
              </CustomButton>
            </Box>
          )}
        </Box>

        <img
          src={data.img}
          alt="chat"
          width={192}
          style={{ position: "absolute", right: "40px", top: "24px" }}
        />
      </Box>
    </Box>
  );
}